import { render, staticRenderFns } from "./NoteCard.vue?vue&type=template&id=01210268&scoped=true"
import script from "./NoteCard.vue?vue&type=script&lang=js"
export * from "./NoteCard.vue?vue&type=script&lang=js"
import style0 from "./NoteCard.vue?vue&type=style&index=0&id=01210268&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01210268",
  null
  
)

export default component.exports